import { sub } from "date-fns";

import { printDate } from "../utils/dateParser";

export const POLICYSTATE_LABELS = {
  ACTIVEPOLICY: "Active",
  CANCELLEDPOLICY: "Cancelled",
  NONRENEWEDPOLICY: "Non-Renewed",
  TRANSFERREDPOLICY: "Transferred"
};

export const POLICYSTATUS_LABELS = {
  PendingCancellation: "Pending Cancellation",
  PendingNonRenewal: "Pending Non-Renewal"
};

export const POLICY_STATUSES = {
  ACTIVE: "Active",
  UPCOMING_RENEWAL: "Upcoming renewal",
  PENDING_NONRENEWAL: "Pending nonrenewal",
  PENDING_CANCELLATION: "Pending cancellation",
  CANCELLED: "Cancelled",
  OPEN_CLAIM: "Active Claim",
  NONRENEWED: "NonRenewed"
};

export const POLICY_STATES = {
  ACTIVE: "ACTIVEPOLICY",
  NONRENEWED: "NONRENEWEDPOLICY",
  CANCELLED: "CANCELLEDPOLICY",
  TRANSFERRED: "TRANSFERREDPOLICY"
};

export const PolicyBillingCardConstants = {
  NEXT_DUE_DATE: "InvoiceDueDateNext",
  NEXT_INVOICE_AMOUNT: "InvoiceAmountNext",
  PAYMENT_PLAN: "Payment Plan",
  PAST_DUE_BALANCE: "PastDueBalance"
};

export const POLICY_STATUS_COLORS = {
  ACTIVE_BACKGROUND_COLOR: "rgb(148, 147, 0, 0.1)",
  PENDING_BACKGROUND_COLOR: "rgb(255, 130, 0, 0.1)",
  CANCELLED_BACKGROUND_COLOR: "rgb(191, 35, 36, 0.1)",
  OPEN_CLAIM_BACKGROUND_COLOR: "rgb(0, 156, 166, 0.1)"
};

export const POLICY_FILTERS = [
  {
    label: "All policies",
    name: "allPolicies",
    filterType: "reset",
    sortField: "updateTimestamp",
    sortDir: "desc",
    featureFlag: "quote-discovery-filters-v2"
  },
  {
    label: "Only my policies",
    name: "createdByUser",
    filterType: "base",
    property: "showAll",
    activeValue: false,
    sortField: "updateTimestamp",
    sortDir: "desc"
  },
  {
    label: "Pending cancellation",
    name: "pendingCancellation",
    slug: "pending-cancellation",
    filterType: "and",
    property: "pendingCancellation",
    activeValue: true,
    sortField: "pendingCancellationEffectiveDate",
    sortDir: "asc"
  },
  {
    label: "Upcoming renewal",
    name: "pendingRenewal",
    slug: "pending-renewal",
    filterType: "and",
    property: "pendingRenewal",
    activeValue: true,
    sortField: "pendingRenewalDate",
    sortDir: "asc",
    featureFlag: "policy-status-filters-extended"
  },
  {
    label: "Pending nonrenewal",
    name: "pendingNonRenewal",
    slug: "pending-non-renewal",
    filterType: "and",
    property: "pendingNonRenewal",
    activeValue: true,
    sortField: "expectedRenewalDate",
    sortDir: "asc",
    featureFlag: "policy-status-filters-extended"
  },
  {
    label: "Cancelled",
    name: "cancelled",
    slug: "cancelled",
    filterType: "and",
    property: "cancelled",
    activeValue: true,
    sortField: "cancelledEffectiveDate",
    sortDir: "desc",
    range: [
      {
        field: "cancelledEffectiveDate",
        param: "gte",
        value: printDate(sub(new Date(), { days: 60 }), "yyyy-MM-dd")
      }
    ],
    featureFlag: "policy-status-filters-extended"
  },
  {
    label: "Open claims",
    name: "openClaims",
    slug: "open-claims",
    filterType: "and",
    property: "claimsStatus",
    activeValue: "open",
    sortField: "updateTimestamp",
    sortDir: "desc",
    featureFlag: "open-search"
  }
];

export const ComponentIDs = {
  NEW_PREMIUM_POPOVER_ICON: "new-premium-popover-icon",
  NEW_PREMIUM_POPOVER: "new-premium-popover"
};

export const POLICY_DISCOVERY_HEADERS = [
  {
    label: "Customer",
    id: "insuredLastName",
    cssSuffix: "customer"
  },
  {
    label: "Policy",
    id: "policyID",
    cssSuffix: "policy"
  },
  {
    label: "Product",
    id: "product",
    cssSuffix: "product"
  },
  {
    label: "Premium",
    id: "premium",
    cssSuffix: "premium"
  },
  {
    label: "Effective Date",
    id: "effectiveDate",
    cssSuffix: "date"
  },
  {
    label: "Status",
    id: "updateTimestamp",
    cssSuffix: "status"
  }
];
